import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 课程列表
  getProjectList(data) {
    return request({
      url: `${process.env.VUE_APP_BIN_PREFIX}/cohf/project/list`,
      method: 'get',
      data,
    });
  },

  // 关联课程
  bindProjectCourse(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/project_course/bindCourse`,
      method: 'post',
      data,
    });
  },

  // 已绑定课程
  bundledProjectCourses(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/project_course/bundledCourses`,
      method: 'get',
      params,
    });
  },

  // 解绑课程
  unbindProjectCourse(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/project_course/unbindCourse`,
      method: 'post',
      data,
    });
  },
};
